"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const yup = __importStar(require("yup"));
const formik_1 = require("formik");
const react_router_dom_1 = require("react-router-dom");
const react_redux_2 = require("react-redux");
const lodash_1 = require("lodash");
const selectors_1 = require("@/store/ducks/components/selectors");
const selectors_2 = require("@/store/ducks/products/selectors");
const selectors_3 = require("@/store/ducks/associatedComponents/selectors");
const products_1 = require("@/store/ducks/products");
const associatedComponents_1 = require("@/store/ducks/associatedComponents");
const listComponentsUseCase_1 = require("@/useCases/components/listComponentsUseCase");
const associateProductToComponentsUseCase_1 = require("@/useCases/productsAssociation/associateProductToComponentsUseCase");
const editProductUseCase_1 = __importDefault(require("@/useCases/products/editProductUseCase"));
const AssociationTable_1 = __importDefault(require("../AssociationTable"));
function ProductEditionAssociationTable() {
    const dispatch = (0, react_redux_2.useDispatch)();
    const { productId } = (0, react_router_dom_1.useParams)();
    react_1.default.useEffect(() => {
        (0, listComponentsUseCase_1.listComponents)()(dispatch);
    }, []);
    const componentsRows = (0, react_redux_1.useSelector)(selectors_1.componentTableRowsSelector);
    const associatedComponents = (0, react_redux_1.useSelector)(selectors_3.associatedComponentsListSelector).map((component) => ({
        name: component.name,
        id: component.id,
        order: component.order,
        unit: component.unit,
    }));
    const productNameToBeAssociated = (0, react_redux_1.useSelector)(selectors_2.productNameToBeAssociatedSelector);
    const originalProductName = (0, react_redux_1.useSelector)(selectors_2.originalProductNameSelector);
    const isSavePromptVisible = (0, react_redux_1.useSelector)(selectors_2.isSavePromptVisibleSelector);
    const initialValues = react_1.default.useMemo(() => ({
        associatedComponents: [
            ...associatedComponents,
            { id: "-", unit: "-", order: 0, name: "Select Component" },
        ],
    }), [associatedComponents]);
    const autocompleteComponentsOptions = react_1.default.useMemo(() => {
        return componentsRows.map((component) => {
            return {
                label: component.name,
                value: component.id,
                unit: component.unit,
                order: component.order,
            };
        });
    }, [componentsRows]);
    yup.addMethod(yup.array, "uniqueArray", function (mapper = (component) => component, message = "") {
        return this.test("uniqueArray", message, function (list) {
            const uniqueValues = new Set(list?.map(mapper));
            const duplicateItensPositions = [];
            const duplicateIds = list
                ?.map((item) => item?.id)
                .filter((item, index, ids) => ids.indexOf(item) !== index);
            list?.forEach((component) => {
                if (duplicateIds?.includes(component?.id)) {
                    duplicateItensPositions.push(list.indexOf(component));
                }
            });
            const duplicateComponentsErrors = list
                ?.filter((component) => {
                if (component?.id && duplicateIds?.includes(component?.id)) {
                    return component;
                }
            })
                .reduce((acc, curr) => {
                const duplicateComponentIndex = list.indexOf(curr);
                acc = {
                    ...acc,
                    [`${[duplicateComponentIndex]}`]: "Duplicate Value",
                };
                return acc;
            }, {});
            if (uniqueValues?.size !== list?.length) {
                throw this.createError({
                    path: `${this.path}`,
                    message: duplicateComponentsErrors || "error",
                });
            }
            return true;
        });
    });
    const validationSchema = yup.object().shape({
        associatedComponents: yup
            .array()
            .of(yup
            .object()
            .shape({
            order: yup.number(),
            name: yup.string().required("Required").min(1).trim(),
            id: yup.string(),
            unit: yup.string(),
        })
            .required("Required")
            .nullable())
            .uniqueArray((item) => {
            return item?.id;
        }, "Error test"),
    });
    const onSubmit = react_1.default.useCallback(async (values) => {
        const payload = values.associatedComponents.slice(0, values.associatedComponents.length - 1);
        if (!productId) {
            dispatch((0, products_1.openProductsToast)({
                status: "error",
                message: "Error saving the product",
            }));
            return;
        }
        if (originalProductName !== productNameToBeAssociated) {
            await (0, editProductUseCase_1.default)(productId, productNameToBeAssociated)(dispatch);
        }
        if (!(0, lodash_1.isEqual)(values, initialValues)) {
            await (0, associateProductToComponentsUseCase_1.associateProductToComponentsUseCase)(productId, payload)(dispatch).then(() => {
                dispatch((0, products_1.onHideSavePrompt)());
            });
        }
    }, [productNameToBeAssociated, dispatch]);
    const onTogglePrompt = react_1.default.useCallback(() => {
        dispatch((0, products_1.onShowSavePrompt)());
    }, [dispatch, products_1.onShowSavePrompt]);
    const onOpenRemoveAssociationModal = react_1.default.useCallback((componentToBeUnlinked, index) => {
        dispatch((0, associatedComponents_1.setRowIndexToBeUnlinked)(index));
        dispatch((0, associatedComponents_1.openDeleteAssociationModal)());
        dispatch((0, associatedComponents_1.setComponentToBeUnlinked)(componentToBeUnlinked));
    }, [
        dispatch,
        associatedComponents_1.setRowIndexToBeUnlinked,
        associatedComponents_1.openDeleteAssociationModal,
        associatedComponents_1.setComponentToBeUnlinked,
    ]);
    return (react_1.default.createElement(formik_1.Formik, { onSubmit: onSubmit, initialValues: initialValues, enableReinitialize: true, validationSchema: validationSchema, validateOnChange: true }, (props) => {
        return (react_1.default.createElement(AssociationTable_1.default, { onDelete: onOpenRemoveAssociationModal, selectComponentOptions: autocompleteComponentsOptions, componentRowInputs: props.values, errors: props.errors, isSavePromptVisible: isSavePromptVisible, onTogglePrompt: onTogglePrompt }));
    }));
}
exports.default = ProductEditionAssociationTable;
